import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Crop } from '../classes/cropModel';
@Injectable({
    providedIn: 'root'
})
export class Transportservice {
    myApi: any;

    constructor(private http: HttpClient) {}

    createPackingType(crop: Crop) {
        return new Promise((resolve, reject) => {
            this.http.post(this.myApi.saveOne + '/transportPackingType', crop).subscribe(result => {
                console.log("result", result);
                resolve(result)
            }, reject);
        })
    }

    updatePackingType(packingObj) {
        let obj = {
            packingTypeId: packingObj.packingTypeId,
            group: packingObj.group
        }
        return new Promise((resolve, reject) => {
            this.http.post(this.myApi.update + '/transportPackingType/one/' + JSON.stringify(obj), packingObj).subscribe(result => {
                console.log("result", result);
                resolve(result)
            }, reject);
        })
    }

    getPackingTypeCount(count) {
        return new Promise((resolve, reject) => {
            this.http.get(this.myApi.getCount + '/transportPackingType/' + JSON.stringify(count)).subscribe(result => {
                // console.log("result", result);
                resolve(result)
            }, reject);
        })
    }

    getPackingType(option) {
        return new Promise((resolve, reject) => {
            this.http.get(this.myApi.getAll + '/transportPackingType/' + JSON.stringify(option)).subscribe(result => {
                console.log("result", result);
                resolve(result)
            }, reject);
        })
    }

    createSubType(crop: Crop) {
        return new Promise((resolve, reject) => {
            this.http.post(this.myApi.saveOne + '/transportSubType', crop).subscribe(result => {
                console.log("result", result);
                resolve(result)
            }, reject);
        })
    }

    updateSubType(subObj) {
        let obj = {
            subTypeId: subObj.subTypeId,
            group: subObj.group
        }
        return new Promise((resolve, reject) => {
            this.http.post(this.myApi.update + '/transportSubType/one/' + JSON.stringify(obj), subObj).subscribe(result => {
                console.log("result", result);
                resolve(result)
            }, reject);
        })
    }

    getSubTypeCount(count) {
        return new Promise((resolve, reject) => {
            this.http.get(this.myApi.getCount + '/transportSubType/' + JSON.stringify(count)).subscribe(result => {
                // console.log("result", result);
                resolve(result)
            }, reject);
        })
    }

    getSubTypeData(option) {
        return new Promise((resolve, reject) => {
            this.http.get(this.myApi.getAll + '/transportSubType/' + JSON.stringify(option)).subscribe(result => {
                console.log("result", result);
                resolve(result)
            }, reject);
        })
    }
}